
const state = {
  show: false,
  financialfirmInfo: {}
}

const actions = {
  updateFinancialfirm (ctx, item) {
    ctx.commit('updateFinancialfirm', item)
  }
}

const mutations = {
  updateFinancialfirm (state, item) {
    state.financialfirmInfo = item
  },
  showAddFinancialfirm (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
